var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('DataEntityList', {
    attrs: {
      "params": _vm.params,
      "initial-value": _vm.initialValue,
      "get": _vm.$api.installment.calculate,
      "watch-param-changes": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            response = _ref.response;
        return [_c('div', {
          staticClass: "installment layout-default layout-default_wide"
        }, [_c('h1', {
          staticClass: "installment-page__title"
        }, [_vm._v("\n      Рассрочка от 05RU\n    ")]), _vm._v(" "), _c('TabManager', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var onClick = _ref2.onClick,
                  activeIndex = _ref2.activeIndex;
              return [_c('ul', {
                staticClass: "installment-tabs"
              }, _vm._l(_vm.pageCategory, function (el) {
                return _c('li', {
                  key: el.id
                }, [_c('a', {
                  staticClass: "installment-tabs__item",
                  class: [{
                    'installment-tabs__item_active': activeIndex === el.id
                  }],
                  on: {
                    "click": function ($event) {
                      onClick(el.id), _vm.pageCategoryID = el.id;
                    }
                  }
                }, [_vm._v("\n              " + _vm._s(el.name) + "\n            ")])]);
              }), 0), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: activeIndex === 0,
                  expression: "activeIndex === 0"
                }]
              }, [_c('div', {
                staticClass: "installment-page"
              }, [_c('div', {
                staticClass: "installment-page__left"
              }, [_c('div', {
                staticClass: "installment-page__left-title"
              }, [_vm._v("\n                Выгоднее, быстрее, без посредников\n              ")]), _vm._v(" "), _c('p', {
                staticClass: "installment-page__left-subtitle"
              }, [_vm._v("\n                Все товары можно оформить в рассрочку онлайн\n              ")]), _vm._v(" "), _c('div', {
                staticClass: "installment-page__left-desc"
              }, [_vm._v("\n                Рассрочка доступна лицам, достигшим 23 лет, проживающим и работающим исключительно на территории Дагестана.\n              ")])]), _vm._v(" "), _c('section', {
                staticClass: "installment-page__section"
              }, [response ? _c('InstallmentCalculate', {
                staticClass: "mb-55",
                attrs: {
                  "initial-state": _vm.params,
                  "data": response,
                  "error": error,
                  "loading": loading
                },
                on: {
                  "update": function ($event) {
                    return _vm.changeParams($event);
                  },
                  "share": function ($event) {
                    return _vm.enableShare();
                  },
                  "qr-code": function ($event) {
                    return _vm.enableQrCode();
                  }
                }
              }) : _vm._e(), _vm._v(" "), _c('div', {
                staticClass: "installment-page__advantages"
              }, [_vm._l(_vm.advantages, function (item) {
                return [_c(item.key === 'lk' ? 'nuxt-link' : 'div', {
                  key: item.key,
                  tag: "component",
                  staticClass: "installment-page__advantage",
                  class: ("installment-page__advantage_" + (item.key)),
                  style: {
                    backgroundColor: ("" + (item.bgColor))
                  },
                  attrs: {
                    "to": item.link
                  }
                }, [_c('img', {
                  attrs: {
                    "src": require(("~/assets/images/svg/rassrochka/" + (item.key) + ".svg")),
                    "alt": item.title
                  }
                }), _vm._v(" "), _c('div', {
                  staticClass: "installment-page__advantage-text"
                }, [_c('p', {
                  staticClass: "installment-page__advantage-title"
                }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                      ")]), _vm._v(" "), _c('p', {
                  staticClass: "installment-page__advantage-description"
                }, [_vm._v("\n                        " + _vm._s(item.description) + "\n                      ")])])])];
              })], 2)], 1)])]), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: activeIndex === 1,
                  expression: "activeIndex === 1"
                }]
              }, [_c('h5', {
                staticClass: "h5 mb-12"
              }, [_vm._v("\n            Оформление\n          ")]), _vm._v(" "), _c('div', _vm._l(_vm.faq.registration, function (item, index) {
                return _c('Toggle', {
                  key: index,
                  scopedSlots: _vm._u([{
                    key: "default",
                    fn: function (_ref3) {
                      var onClick = _ref3.onClick,
                          isActive = _ref3.isActive;
                      return [_c('div', {
                        staticClass: "installment__question",
                        on: {
                          "click": onClick
                        }
                      }, [_c('div', {
                        staticClass: "collapse",
                        class: [{
                          collapse_active: isActive
                        }]
                      }, [_c('a', {
                        staticClass: "link link_wu installment__question-title"
                      }, [_vm._v(_vm._s(item.question))])]), _vm._v(" "), isActive ? _c('div', {
                        staticClass: "mt-8"
                      }, [_c('p', {
                        staticClass: "p"
                      }, [_vm._v("\n                      " + _vm._s(item.answer) + "\n                    ")])]) : _vm._e()])];
                    }
                  }], null, true)
                });
              }), 1), _vm._v(" "), _c('h3', {
                staticClass: "h5 mt-25 mb-12"
              }, [_vm._v("\n            Товары\n          ")]), _vm._v(" "), _c('div', _vm._l(_vm.faq.products, function (item, index) {
                return _c('Toggle', {
                  key: index,
                  scopedSlots: _vm._u([{
                    key: "default",
                    fn: function (_ref4) {
                      var onClick = _ref4.onClick,
                          isActive = _ref4.isActive;
                      return [_c('div', {
                        staticClass: "installment__question",
                        on: {
                          "click": onClick
                        }
                      }, [_c('div', {
                        staticClass: "collapse",
                        class: [{
                          collapse_active: isActive
                        }]
                      }, [_c('a', {
                        staticClass: "link link_wu installment__question-title"
                      }, [_vm._v(_vm._s(item.question))])]), _vm._v(" "), isActive ? _c('div', {
                        staticClass: "mt-8"
                      }, [_c('p', {
                        staticClass: "p"
                      }, [_vm._v("\n                      " + _vm._s(item.answer) + "\n                    ")])]) : _vm._e()])];
                    }
                  }], null, true)
                });
              }), 1), _vm._v(" "), _c('h3', {
                staticClass: "h5 mt-25 mb-12"
              }, [_vm._v("\n            Оплата и скидки\n          ")]), _vm._v(" "), _c('div', _vm._l(_vm.faq.payments, function (item, index) {
                return _c('Toggle', {
                  key: index,
                  scopedSlots: _vm._u([{
                    key: "default",
                    fn: function (_ref5) {
                      var onClick = _ref5.onClick,
                          isActive = _ref5.isActive;
                      return [_c('div', {
                        staticClass: "installment__question",
                        on: {
                          "click": onClick
                        }
                      }, [_c('div', {
                        staticClass: "collapse",
                        class: [{
                          collapse_active: isActive
                        }]
                      }, [_c('a', {
                        staticClass: "link link_wu installment__question-title"
                      }, [_vm._v(_vm._s(item.question))])]), _vm._v(" "), isActive ? _c('div', {
                        staticClass: "mt-8"
                      }, [_c('p', {
                        staticClass: "p"
                      }, [_vm._v("\n                      " + _vm._s(item.answer) + "\n                    ")])]) : _vm._e()])];
                    }
                  }], null, true)
                });
              }), 1)]), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: activeIndex === 2,
                  expression: "activeIndex === 2"
                }],
                staticClass: "installment-law-info"
              }, [_c('header', {
                staticClass: "installment-law-info__header"
              }, [_c('h3', [_vm._v("ИП Якубова Тамара Омаровна")])]), _vm._v(" "), _c('div', {
                staticClass: "installment-law-info__row"
              }, [_c('h4', [_vm._v("Юридический адрес")]), _vm._v(" "), _c('span', [_vm._v("г. Махачкала, ул. Зои Космодемьянской, д.52, кв. 2")])]), _vm._v(" "), _c('div', {
                staticClass: "installment-law-info__row"
              }, [_c('h4', [_vm._v("Номер горячей линии")]), _vm._v(" "), _c('span', [_vm._v("8 (800) 511-05-05")])]), _vm._v(" "), _c('div', {
                staticClass: "installment-law-info__row"
              }, [_c('h4', [_vm._v("Email")]), _vm._v(" "), _c('a', {
                attrs: {
                  "href": "mailto:05scc@05.ru"
                }
              }, [_vm._v("05scc@05.ru")])])])];
            }
          }], null, true)
        }), _vm._v(" "), _c('Modal', {
          attrs: {
            "padding": "30px",
            "show": _vm.qrCodeActive,
            "title": "Наведите камеру, чтобы открыть страницу",
            "max-width": "350px",
            "mobile-fullscreen": ""
          },
          on: {
            "close": function ($event) {
              return _vm.disabledModalQrCode();
            }
          }
        }, [_c('div', {
          staticClass: "installment-page__qrcode"
        }, [_vm.qrCodeActive ? _c('QrcodeVue', {
          attrs: {
            "value": _vm.urlPage,
            "size": "250"
          }
        }) : _vm._e()], 1)])], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }